module.exports = __webpack_public_path__ + "img/小程序.2fd5bb58.jpeg";